import * as HSWidgets from '@/Components/Common/HSWidget';

export const HSRegistry = {
  ...HSWidgets,
};
